import EditorLayoutMobile from '@/components/yearbook/mobile/EditorLayoutMobile';

const IndexEditorMobile = () => {
  return <EditorLayoutMobile />;
};

export default IndexEditorMobile;
